import dayjs from 'dayjs';

const getDatesDifferenceInUnits = (startDate: Date, endDate: Date = new Date()) => {
  const differenceInSeconds = dayjs(endDate).diff(startDate, 'seconds');
  const differenceInMinutes = Math.floor(differenceInSeconds / 60);
  const days = Math.floor(differenceInMinutes / (60 * 24));
  const hours = Math.floor(differenceInMinutes / 60);
  const minutes = differenceInMinutes;
  const seconds = differenceInSeconds;

  return {
    days,
    hours,
    minutes,
    seconds,
  };
};

const secondsInADay = 86400;
const secondsInAnHour = 3600;
const secondsInAMinute = 60;

const convertSecondsToTimeParts = (differenceInSeconds: number) => {
  const result = {
    seconds: 0,
    minutes: 0,
    hours: 0,
    days: 0,
  };

  let currentValue = differenceInSeconds;

  if (currentValue >= secondsInADay) {
    const daysCount = Math.floor(currentValue / secondsInADay);
    result.days = daysCount;

    currentValue = currentValue % secondsInADay;
  }

  if (currentValue >= secondsInAnHour) {
    const hoursCount = Math.floor(currentValue / secondsInAnHour);
    result.hours = hoursCount;

    currentValue = currentValue % secondsInAnHour;
  }

  if (currentValue >= secondsInAMinute) {
    const minutesCount = Math.floor(currentValue / secondsInAMinute);
    result.minutes = minutesCount;

    currentValue = currentValue % secondsInAMinute;
  }

  if (currentValue > 0) {
    result.seconds = Math.floor(currentValue);
  }

  return result;
};

const getDateRangeDuration = (startDate: Date, endDate: Date = new Date()) => {
  const differenceInMinutes = getDatesDifferenceInUnits(startDate, endDate).minutes;
  const hours = Math.floor(differenceInMinutes / 60);
  const minutes = differenceInMinutes % 60;

  return {
    hours,
    minutes,
  };
};

export { getDateRangeDuration, getDatesDifferenceInUnits, convertSecondsToTimeParts };
